import { render, staticRenderFns } from "./App6Grid.vue?vue&type=template&id=08691cb6&"
import script from "./App6Grid.vue?vue&type=script&lang=js&"
export * from "./App6Grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports